document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-menu-toggle]').forEach((button) => {
    button.addEventListener('click', () => {
      const menu = document.querySelector('[data-mobile-menu]');
      if (!menu) return;
      const isOpen = menu.classList.toggle('is-open');
      button.setAttribute('aria-expanded', String(isOpen));
      document.body.classList.toggle('menu-open', isOpen);
    });
  });

  document.querySelectorAll('[data-gallery-thumb]').forEach((button) => {
    button.addEventListener('click', () => {
      const gallery = button.closest('[data-product-gallery]');
      const mainImage = gallery && gallery.querySelector('[data-gallery-main]');
      if (!mainImage) return;
      mainImage.src = button.dataset.imageSrc;
      mainImage.srcset = button.dataset.imageSrcset || '';
      mainImage.alt = button.dataset.imageAlt || '';
      gallery.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => thumb.classList.remove('is-active'));
      button.classList.add('is-active');
    });
  });

  document.querySelectorAll('[data-variant-select]').forEach((select) => {
    select.addEventListener('change', () => {
      const root = select.closest('[data-product-root]');
      const option = select.options[select.selectedIndex];
      if (!root || !option) return;
      const price = root.querySelector('[data-product-price]');
      const submit = root.querySelector('[data-add-to-cart]');
      if (price && option.dataset.price) price.textContent = option.dataset.price;
      if (submit) {
        const available = option.dataset.available === 'true';
        submit.disabled = !available;
        submit.textContent = available ? submit.dataset.availableText : submit.dataset.soldOutText;
      }
    });
  });

  document.querySelectorAll('[data-quantity-control]').forEach((control) => {
    const input = control.querySelector('input[type="number"]');
    if (!input) return;
    control.querySelectorAll('button').forEach((button) => {
      button.addEventListener('click', () => {
        const change = button.dataset.quantityAction === 'increase' ? 1 : -1;
        input.value = Math.max(Number(input.min || 1), Number(input.value || 1) + change);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });
});
